import Cookies from 'js-cookie'

const TokenKey = 'antu-wps-Token'

export function getToken() {
  console.log("-----Cookies")
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
